<template>
    <div class="budget-followup">

        <div v-if="data && !loading">
            <div style="text-align:center;padding-top:15px;margin-bottom:30px;">
                Du har lagt budget for perioden <b>{{ data.from | moment('DD/MM/YYYY') }} - {{ data.to | moment('DD/MM/YYYY') }}</b>
            </div>

            <div style="display:flex;justify-content:center;">
                <div class="employee-switcher" style="margin-bottom:30px;">
                    <div class="employee-switcher-option lg" @click="selectedSubMenuItem = 'hours'" :class="{'selected': selectedSubMenuItem === 'hours'}">
                        Solgte timer
                    </div>
                    <div class="employee-switcher-option lg" @click="selectedSubMenuItem = 'cph'" :class="{'selected': selectedSubMenuItem === 'cph'}">
                        DB pr. time
                    </div>
                    <div class="employee-switcher-option lg" @click="selectedSubMenuItem = 'ebitda'" :class="{'selected': selectedSubMenuItem === 'ebitda'}">
                        EBITDA
                    </div>
                </div>
            </div>

            <budget-hours v-show="selectedSubMenuItem === 'hours'" />

            <budget-cph v-show="selectedSubMenuItem === 'cph'" />

            <budget-ebitda v-show="selectedSubMenuItem === 'ebitda'" />
        </div>

        <div v-else-if="!data && !loading">
            <div class="placeholder padding" style="text-align:center;">
                Du har endnu ikke lagt et budget
                <br><br>
                <router-link :to="{name: 'BudgetPlanning'}" tag="button" class="budget-btn">
                    Læg et budget
                </router-link>
            </div>
        </div>

        <div v-else>
            <box-loading />
        </div>

    </div>
</template>

<script>
import * as budgetService from '@/services/budgetService'
import VueApexCharts from 'vue-apexcharts'
import budgetHours from './components/budgetHours.vue'
import budgetCph from './components/budgetCph.vue'
import budgetEbitda from './components/budgetEbitda.vue'
import BoxLoading from '../../../components/elements/BoxLoading.vue'

export default {
    data () {
        return {
            selectedSubMenuItem: 'hours',
            data: null,
            loading: true
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData () {
            budgetService.overview({}, (response) => {
                console.log(response)
                this.data = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
            /* budgetService.hoursAndCph({}, (response) => {
                this.hoursGraphOptions.labels = response.data.hours.graph.labels
                this.hoursGraphSeries.push({name: 'Budget', data: response.data.hours.graph.budget_series})
                this.hoursGraphSeries.push({name: 'Faktisk', data: response.data.hours.graph.actual_series})
                this.data = response.data
                console.log(response.data)
            }, (err) => {
                console.log(err)
            }) */
        }
    },
    components: {
        VueApexCharts,
        budgetHours,
        budgetCph,
        budgetEbitda,
        BoxLoading
    }
}
</script>



// WEBPACK FOOTER //
// budgetFollowup.vue?6abb3a11